module.exports = __webpack_public_path__ + "static/media/ios-card.e6ed2326.svg";